<template>
  <div class="flex">
    <img
      class="size-88 mr-6 bg-#D8D8D8 rounded-8"
      :src="goods.imgUrl || goods.imageUrl"
    />
    <div class="flex-1 flex flex-col justify-between">
      <div class="text-#333 text-left leading-14 line-clamp-2">
        {{ goods.goodsName }}
      </div>
      <div v-if="goods.price >= 0 && goods.price !== null" class="flex justify-between">
        <div class="text-14 text-#333 font-bold">
          {{ formatPrice(goods.price) }}
        </div>
        <div
          class="bg-#FFC045 rounded-14 w-73 h-24 flex justify-center items-center text-10 text-#333 font-600"
          @click="$emit('send', { goods: $props.goods })"
        >
          {{ $t("message.send") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useSetting } from "@/composables/use-setting";

defineProps<{
  goods: any;
}>();

defineEmits<{
  send: [any];
}>();

const { formatPrice } = useSetting();
</script>
